// VideoPlayerModal.tsx
import React from "react";
import { Modal } from "antd";

interface VideoPlayerModalProps {
  open: boolean;
  onClose: () => void;
  videoName?: string;
  fileLink?: string;
}

export default function VideoPlayerModal({
  open,
  onClose,
  videoName,
  fileLink,
}: VideoPlayerModalProps): React.ReactElement {
  return (
    <Modal
      title={videoName || "Video"}
      open={open}
      onCancel={onClose}
      width={1024}
      footer={false}
      destroyOnClose
      styles={{ container: { background: "#00000055" } }}
    >
      {fileLink && (
        <video
          controls
          autoPlay
          style={{ width: "100%", borderRadius: 8 }}
          src={fileLink}
        >
          Your browser does not support the video tag.
        </video>
      )}
    </Modal>
  );
}
